export default __webpack_public_path__ + "static/media/beatup.84453fcc.png";